import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { Card, Button, Form, Input, Select, Spin, message } from "antd";
import moment from "moment";
import Service from "../../../services/users";

const UserForm = (props) => {
  const history = useHistory();

  const Option = Select.Option;
  const FormItem = Form.Item;

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [membershipExpiry, setMembershipExpiry] = useState(null);
  const [createdAt, setCreatedAt] = useState(null);
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    getInitialData();
  }, []);

  const getInitialData = async () => {
    const { match } = props;

    let { id } = match.params;

    if (id) {
        try {
        const details = await Service.getUserDetails(id);
        setName(details?.name || "");
        setEmail(details?.email || "");
        setPhoneNumber(details?.phoneNumber || "");
        setIsActive(details?.isActive !== undefined ? details.isActive : true);
        setIsVerified(details?.isVerified !== undefined ? details.isVerified : false);
        setIsPremium(details?.isPremium !== undefined ? details.isPremium : false);
        setCreatedAt(details?.createdAt || null);
        setUpdatedAt(details?.updatedAt || null);
        setMembershipExpiry(details?.membershipExpiry || null);
        setIsEdit(true);
        setUserId(id);
      } catch (error) {
        message.error("Failed to load user details");
        console.error(error);
      }
    }
  }

  const handleName = (e) => {
    setName(e.target.value);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handlePhoneNumber = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleStatus = (val) => {
    setIsActive(val);
  };

  const handleVerified = (val) => {
    setIsVerified(val);
  };

  const handlePremium = (val) => {
    setIsPremium(val);
  };

  const onSubmit = async () => {
    if (!name || !email  ) {
      message.error("Please fill in all required fields");
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      message.error("Please enter a valid email address");
      return;
    }

    setLoading(true);

    try {
      let userResponse;
      if (isEdit && userId) {
        // Update existing user
        userResponse = await Service.updateUser(
          { _id: userId },
          {
            name,
            email,
            phoneNumber,
            isActive,
            isVerified: isVerified,
            isPremium: isPremium,
            membershipExpiry,
            updatedAt: new Date()
          }
        );

        if (userResponse?.message === "user.updated") {
          message.success("User Updated!");
          history.push("/users");
        } else if (userResponse?.error) {
          message.error(userResponse.error);
        } else {
          message.error("Failed to update user");
        }
      } else {
        message.error("Creating new users is not supported through this form");
      }
    } catch (error) {
      message.error(error.response?.data?.error || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  return (
    <Spin spinning={loading} size="large">
      <div className="menu-editor-box card-pad-new menu-cate-list users-main-page categoryForm-main">
        <div className="payout-report-box">
          <Card className="gx-card breadcrumb-box" title="">
            <div className="ant-row hd-title">
              <div className="ant-col-md-12">
                <h1>Manage User</h1>
              </div>
              <div className="ant-col-md-12">
                <div className="orders-item top-section filter-box ">
                  <div className="drop-filter-cover">
                    <Select
                      className="select-box"
                      defaultValue={true}
                      value={isActive}
                      onChange={handleStatus}
                    >
                      <Option value={true}>Enabled</Option>
                      <Option value={false}>Disabled</Option>
                    </Select>
                  </div>
                </div>
              </div>
            </div>
            <div className="ant-row gx-mt-4">
              <div className="ant-col-md-24">
                <div className="item-detail-edit-box">
                  <div className="ant-row">
                    <div className="ant-col-md-12">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Name</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Name"
                          value={name}
                          onChange={handleName}
                        />
                      </FormItem>
                    </div>
                    <div className="ant-col-md-12">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Email</span>}
                      >
                        <Input
                          type="email"
                          placeholder="Email"
                          value={email}
                          onChange={handleEmail}
                        />
                      </FormItem>
                    </div>
                  </div>
                 
                  <div className="ant-row gx-mt-4">
                 
                    <div className="ant-col-md-12">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label="Verified"
                      >
                        <Select
                          className="select-box"
                          value={isVerified}
                          onChange={handleVerified}
                        >
                          <Option value={true}>Yes</Option>
                          <Option value={false}>No</Option>
                        </Select>
                      </FormItem>
                    </div>
                    <div className="ant-col-md-12">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label="Premium"
                      >
                        <Select
                          className="select-box"
                          value={isPremium}
                          onChange={handlePremium}
                        >
                          <Option value={true}>Yes</Option>
                          <Option value={false}>No</Option>
                        </Select>
                      </FormItem>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <div className="ant-row gx-m-0 btn-right">
            <div className="ant-row gx-m-0 btn-left">
              <Button
                type="danger"
                className="color-white"
                onClick={history.goBack}
              >
                Back
                </Button>
            </div>

            <Button
              type="primary"
              className="color-white"
              onClick={onSubmit}
            >
              Save
              </Button>
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default UserForm;